import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import spacetime from 'spacetime/immutable';
import {Trans} from '@lingui/macro';
import PropTypes from 'prop-types';

import cls from 'classnames';
import s from './Details360.css';

export default function Details360(props) {
  const rdxState = useSelector(state => state);

  const {evaluations, campaignStart, campaignEnd} = props;

  const usersToEval = useSelector(state => state.getIn(['questionnaire360', 'data']));
  const loggedInUserId = useSelector(state => state.getIn(['user', 'data', 'id']));

  const [totalEvaluations, setTotalEvaluations] = useState(0);
  const [completedEvaluations, setCompletedEvaluations] = useState(0);

  const completedPercent = Math.round((completedEvaluations / totalEvaluations) * 100) || 0;
  const MAX_PROGESS = 99;
  const timeProgress = getTimeProgress(campaignStart, campaignEnd);

  useEffect(
    () => {
      if (!evaluations) return;

      let completed = evaluations
        .filter(item => item.get('user_is_evaluated') === 'y')
        .reduce(total => total + 1, 0);

      setTotalEvaluations(evaluations.size || 0);
      setCompletedEvaluations(isNaN(completed) ? 0 : completed);
    },
    [evaluations]
  );

  function getTimeProgress(startDate, endDate) {
    const start = startDate && spacetime(startDate);
    const end = endDate && spacetime(endDate);

    if (!start || !end) return 0;

    const deltaTot = end.epoch - start.epoch;
    const now = spacetime.now();
    const deltaNow = end.epoch - now.epoch;
    let delta = deltaTot - deltaNow;

    if (delta < 0) delta = 0;

    return Math.max(Math.min(Math.round((delta / deltaTot) * 100), MAX_PROGESS), 0);
  }

  const isAuto = usersToEval.some(user => user.get('id') === loggedInUserId);
  const isBoth = isAuto && usersToEval.some(user => user.get('id') !== loggedInUserId);

  const lang = rdxState.getIn(['userCampaign', 'data', 'lang']);

  const translations = rdxState.getIn(['tests', 'current', 'labels360']);

  let description_data = '';

  translations.forEach(tr => {
    if (tr.get('lang') == lang) {
      if (isBoth) {
        description_data = tr.get('details_360');
      } else if (isAuto) {
        description_data = tr.get('details_auto');
      } else {
        description_data = tr.get('details_etero');
      }
    }
  });

  return (
    <div className={s.Details360}>
      <h2>
        <Trans id="details360.title">Feedback</Trans>
      </h2>

      <div className={s.ContentContainer}>
        <div dangerouslySetInnerHTML={{__html: description_data}} />

        <section className={s.CompletedSection}>
          <h4 className={s.MiniTitle}>
            <Trans id="dashboard.completed_evaluations">Valutazioni Completate</Trans>
          </h4>
          <div className={s.CompletedTests}>
            <span className={s.Number}>{completedEvaluations}</span>
            <span className={s.NumberSeparator}>
              <Trans id="dashboard.out_of">su</Trans>
            </span>
            <span className={s.Number}>{totalEvaluations}</span>
          </div>
        </section>

        <section className={s.ProgressSection}>
          <h4 className={s.MiniTitle}>
            <Trans id="dashboard.advancement">Avanzamento</Trans>
          </h4>
          <div className={s.ProgressContent}>
            <svg className={s.Pie} viewBox="0 0 32 32">
              <defs>
                <linearGradient id="mygradient">
                  <stop offset="5%" className={s.StartColor} />
                  <stop offset="95%" className={s.StopColor} />
                </linearGradient>
              </defs>
              <circle
                className={s.Circle}
                fill="url(#mygradient)"
                r="16"
                cx="16"
                cy="16"
                style={{strokeDasharray: `${completedPercent} 100`}}
              />
              <circle className={s.InsideCirle} r="12" cx="16" cy="16" />
            </svg>

            <span className={s.Number}>{completedPercent}%</span>
          </div>
        </section>

        {campaignEnd && (
          <section className={s.TimeProgressSection}>
            <h4 className={s.MiniTitle}>
              <Trans id="dashboard.end_date.">Scadenza</Trans>
            </h4>

            <div className={s.BarContainer}>
              <span className={s.Date}>{spacetime(campaignEnd).format('dd.MM.yy')}</span>

              {campaignStart && (
                <div
                  className={cls(
                    s.ProgressBar,
                    timeProgress >= MAX_PROGESS && s.ProgressBar_Complete
                  )}
                >
                  <span
                    className={s.ProgressBar__Bar}
                    style={{
                      width: `${timeProgress}%`,
                    }}
                  />
                </div>
              )}
            </div>
          </section>
        )}
      </div>
    </div>
  );
}

Details360.propTypes = {
  evaluations: PropTypes.object,
  campaignStart: PropTypes.string,
  campaignEnd: PropTypes.string,
};
